export function MailWhiteIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66732 3.16675C2.21013 3.16675 1.83398 3.54289 1.83398 4.00008V12.0001C1.83398 12.4573 2.21013 12.8334 2.66732 12.8334H13.334C13.7912 12.8334 14.1673 12.4573 14.1673 12.0001V4.00008C14.1673 3.54289 13.7912 3.16675 13.334 3.16675H2.66732ZM0.833984 4.00008C0.833984 2.99061 1.65784 2.16675 2.66732 2.16675H13.334C14.3435 2.16675 15.1673 2.99061 15.1673 4.00008V12.0001C15.1673 13.0096 14.3435 13.8334 13.334 13.8334H2.66732C1.65784 13.8334 0.833984 13.0096 0.833984 12.0001V4.00008Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.924411 3.71331C1.08277 3.48709 1.39453 3.43207 1.62076 3.59043L8.00069 8.05638L14.3806 3.59043C14.6069 3.43207 14.9186 3.48709 15.077 3.71331C15.2353 3.93954 15.1803 4.2513 14.9541 4.40966L8.28743 9.07633C8.11527 9.19684 7.88612 9.19684 7.71396 9.07633L1.0473 4.40966C0.821071 4.2513 0.766054 3.93954 0.924411 3.71331Z"
        fill="white"
      />
    </svg>
  )
}
